import { Button, ButtonProps } from "@altimateai/lego";
import { useAgentChat } from "../../hooks/useAgentChat";
import { cn } from "../../../../shared/utils";

const ChatTriggerLink = ({
  text,
  buttonProps,
}: {
  text: string;
  buttonProps?: ButtonProps;
}) => {
  const { sendMessage } = useAgentChat();

  return (
    <Button
      variant="secondary"
      onClick={() => sendMessage({ message: text })}
      color="link"
      key={text}
      {...buttonProps}
      className={cn(
        "al-border al-border-primary-500 al-rounded-full al-p-2 !al-justify-start al-text-left al-h-auto",
        buttonProps?.className,
      )}
      style={{ whiteSpace: "normal", ...buttonProps?.style }}
    >
      {text}
    </Button>
  );
};

export default ChatTriggerLink;
